// Environment configuration for production - India region
export const environment = {
  production: true,
  environmentName: 'prod-india',
  apiUrl: '',
  debugMode: false,
  enableLogs: false, // Disable console logs for production environment
  featureFlags: {
    enableAnalytics: true,
    enableExperimentalFeatures: false
  },
  services: {
    auth: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/auth/v1',
      auth0ClientId: 'XKw5xjrxIUgXmRvB9G8kWoJpHw0jo0xl',
      auth0Domain: 'login.hundredxinc.co.in',
      auth0AudienceDomain: 'hundredxinc.auth0.com',
      auth0CallbackURL: 'https://admin.hundredxinc.co.in/login',
      federatedSignout: false
    },
    firebaseToken: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/auth/v1/firebase/token'
    },
    account: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/account/v1'
    },
    contact: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/contact/v1'
    },
    feedback: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/feedback/v1'
    },
    participant: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/participant/v1'
    },
    transaction: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/transaction/v1'
    },
    solution: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/solution/v1',
      efgAccountId: 1017 // Needs to be updated once one is made
    },
    cbreService: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/cbre/v1'
    },
    reporting: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/reporting/v1'
    },
    data: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/data/v1'
    },
    regionSync: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/region-sync'
    },
    masterData: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/master-data/v1'
    },
    plc: {
      baseUrl: 'https://api.hundredxinc.co.in',
      basePath: '/plc/v1'
    }
  }
};
